const SUPABASE_ENV_WHITESPACE = /[\t\n\f\r ]+/g

/**
 * Strip copy/paste whitespace artifacts from public Supabase env vars.
 * This keeps browser-side realtime auth from inheriting `%0A` in websocket URLs.
 */
function sanitizeSupabasePublicEnvValue(value: string | null | undefined): string | undefined {
  const sanitized = value?.replace(SUPABASE_ENV_WHITESPACE, '')
  return sanitized ? sanitized : undefined
}

export function getPublicSupabaseEnv() {
  return {
    url: sanitizeSupabasePublicEnvValue(process.env.NEXT_PUBLIC_SUPABASE_URL),
    anonKey: sanitizeSupabasePublicEnvValue(process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY),
  }
}
